// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getPerformance } from "firebase/performance";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBfXGRA14K8QeZoswrSL-lH-6W77FwxNAU",
  authDomain: "winnepocket-landscaping.firebaseapp.com",
  projectId: "winnepocket-landscaping",
  storageBucket: "winnepocket-landscaping.firebasestorage.app",
  messagingSenderId: "295476519665",
  appId: "1:295476519665:web:6a64d47345a2e93fa97f50",
  measurementId: "G-F3JEDR16NJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
export const perf = getPerformance(app);

export default app;